import {lazy} from 'react';

export const coverageModuleRoutes = [
    {
        id: 'addCoverage',
        path: '/add-coverage',
        component: lazy(() => import('./routes/AddCoverageRoute')),
    },
];
